module.exports = __webpack_public_path__ + "img/danzhou.c6aef821.png";